import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=85265c44&scoped=true"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&id=85265c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85265c44",
  null
  
)

export default component.exports